import { ListIcon } from 'morpheus-ui';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '../../../../core/components/atoms/Button';
import ContentModal from '../contentModal';
import { useScreenSize } from '../../../../core/hooks/useScreenSize';
import { useWindowBreakpoints } from '../../../../core/hooks/useWindowBreakpoints';

interface IContentFooter {
  nextContent: () => void;
  previousContent: () => void;
  contentModalInitialTab: number;
  contentModalSubtitle: string;
  currentIndex: number;
  contentLength: number;
  previousLabel: string;
  nextLabel: string;
  mainLabel?: string;
  contentType?: string;
}

function ContentFooter({
  contentModalInitialTab,
  contentModalSubtitle,
  nextContent,
  previousContent,
  currentIndex,
  contentLength,
  previousLabel,
  nextLabel,
  mainLabel = 'Lista de conteúdos',
  contentType = 'lesson',
}: IContentFooter) {
  const { discipline, module, subject, slug } = useParams();
  const [isContentModalOpen, setIsContentModalOpen] = useState(false);

  const screenSize = useScreenSize();
  const windowBreakpoints = useWindowBreakpoints();

  const contentModal = () => {
    return (
      <ContentModal
        isOpen={isContentModalOpen}
        onClose={() => setIsContentModalOpen(false)}
        slug={slug || ''}
        subtitle={contentModalSubtitle}
        discipline={discipline || ''}
        module={module || ''}
        subject={subject || ''}
        initialContent={null}
        initialTab={contentModalInitialTab}
        contentType={contentType}
      />
    );
  };

  if (screenSize < windowBreakpoints.lg) {
    return (
      <>
        <footer
          className='
            font-noto -mt-10 mb-0 flex
            h-20 w-full
            flex-row gap-xl border-t-hairline border-t-mono-color-lightest bg-color-lightest
            px-8 py-5 shadow-level-2 z-[300]'
        >
          <Button
            variant='outlined'
            onlyIcon
            LeftIcon={'chevron_left'}
            iconType='material'
            onClick={previousContent}
            disabled={currentIndex <= 0}
          />
          <Button
            onClick={() => {
              setIsContentModalOpen(true);
            }}
            variant='text'
            className='flex-1 items-center justify-center'
            LeftIcon={ListIcon}
            classNameIcon='fill-button-color-tertiary-default'
            iconSize='medium'
            iconType='svg'
          >
            {mainLabel}
          </Button>
          <Button
            variant='outlined'
            onlyIcon
            LeftIcon={'chevron_right'}
            iconType='material'
            onClick={nextContent}
            disabled={currentIndex >= contentLength - 1}
          />
        </footer>
        {contentModal()}
      </>
    );
  }

  return (
    <>
      <footer
        className='
                font-noto fixed bottom-0 left-0
                flex h-20 w-full flex-row gap-xl
                border-t-hairline border-t-mono-color-lightest bg-color-lightest px-8 py-5
                shadow-level-2 z-[300]'
      >
        <Button
          variant='outlined'
          onClick={previousContent}
          disabled={currentIndex <= 0}
          className='fill-black'
        >
          {previousLabel}
        </Button>
        <Button
          onClick={() => {
            setIsContentModalOpen(true);
          }}
          variant='text'
          className='flex-1 items-center justify-center'
          classNameIcon='fill-button-color-tertiary-default'
          LeftIcon={ListIcon}
          iconSize='medium'
          iconType='svg'
        >
          {mainLabel}
        </Button>
        <Button
          variant='outlined'
          onClick={nextContent}
          disabled={currentIndex >= contentLength - 1}
          className='fill-black'
        >
          {nextLabel}
        </Button>
      </footer>
      {contentModal()}
    </>
  );
}

export default ContentFooter;
